import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { useCallback, useMemo } from 'react';
import { ThemeType } from './types';
import { darken, IconButton, lighten, styled, Tooltip } from '@mui/material';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { BrightnessAuto, NightsStay, WbSunny } from '@mui/icons-material';
import { changeUserTheme } from './actions';
import { selectThemeType } from './selector';
import branding from 'shared/app/model/branding';
const Fab = styled(IconButton)(({ theme }) => {
    const is_autoscan = branding.code === 'autoscan';
    return {
        width: 35,
        height: 35,
        backgroundColor: 'transparent',
        '&:hover': {
            color: theme.palette.mode == 'dark' || is_autoscan
                ? lighten(theme.palette.text.secondary, 0.9)
                : darken(theme.palette.text.secondary, 0.8),
            backgroundColor: 'transparent',
        },
        [theme.breakpoints.down('xs')]: {
            color: theme.palette.common.white,
            '&:hover': {
                color: darken(theme.palette.common.white, 0.3),
            },
        },
    };
});
const fabs = [
    {
        icon: _jsx(BrightnessAuto, {}),
        label: 'Системная тема',
    },
    {
        icon: _jsx(WbSunny, {}),
        label: 'Светлая тема',
    },
    {
        icon: _jsx(NightsStay, {}),
        label: 'Тёмная тема',
    },
];
export function SmallThemeSwitcherImpl(props) {
    const { themeType, onChange, useNotInHeader } = props;
    const chosen_theme = themeType ?? ThemeType.SYSTEM;
    const onChangeTheme = useCallback(() => {
        const new_theme = chosen_theme === ThemeType.DARK ? ThemeType.SYSTEM : chosen_theme + 1;
        onChange(new_theme);
    }, [onChange, chosen_theme]);
    const fab = fabs[chosen_theme];
    const is_autoscan = useMemo(() => branding.code === 'autoscan', [branding]);
    return (_jsx(Tooltip, { title: fab.label, children: _jsx(Fab, { onClick: onChangeTheme, sx: {
                color: (theme) => useNotInHeader
                    ? theme.palette.text.secondary
                    : is_autoscan
                        ? 'rgba(255,255,255,0.7)'
                        : theme.palette.text.secondary,
            }, children: fab.icon }) }));
}
export const SmallThemeSwitcher = connect(createStructuredSelector({
    themeType: selectThemeType,
}), {
    onChange: changeUserTheme,
})(SmallThemeSwitcherImpl);
